import { useEffect, useState } from 'react'
import { initializeCastReceiver } from './core/cast/CastReceiverManager'
import { detectTouchDevice } from './core/device/DeviceDetection'
import Layout from './features/ui/components/Layout'
import LoadingScreen from './features/ui/components/LoadingScreen'

function App() {
  const [isLoading, setIsLoading] = useState(true)
  const [hasTouchScreen, setHasTouchScreen] = useState(false)
  
  useEffect(() => {
    // Detect touch device
    console.log('⚡ App: Running touch device detection')
    const isTouchDevice = detectTouchDevice()
    console.log('⚡ App: Touch detection result:', isTouchDevice)
    setHasTouchScreen(isTouchDevice)
    
    // Initialize Cast Receiver
    try {
      initializeCastReceiver()
    } catch (error) {
      console.error('Cast SDK initialization error:', error)
    }
    
    // Set a reasonable loading time for the Cast receiver to initialize
    const timer = setTimeout(() => {
      setIsLoading(false)
    }, 2000)
    
    return () => clearTimeout(timer)
  }, [])
  
  if (isLoading) {
    return <LoadingScreen />
  }
  
  return (
    <Layout hasTouchScreen={hasTouchScreen} />
  )
}

export default App
